import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Protected = ({ Component }) => {
  const { userResult } = useSelector((state) => state.Auth);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (userResult?.userid || storedUser?.userid || userResult?.vendorid || storedUser?.vendorid) {
      setLoading(false); // user is authenticated
    } else {
      navigate("/");
    }
  }, [userResult, navigate]);

  if (loading) return <div>Loading...</div>;

  return <Component />;
};

export default Protected;
